import { render, staticRenderFns } from "./JbSupSolicitacaoOpcoes.vue?vue&type=template&id=a9958a2c&"
import script from "./JbSupSolicitacaoOpcoes.vue?vue&type=script&lang=js&"
export * from "./JbSupSolicitacaoOpcoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports